var map = {
	"./Bronze.svg": 890,
	"./Diamond.svg": 891,
	"./Gold.svg": 892,
	"./Silver.svg": 893,
	"./company-default.png": 158,
	"./dummy.jpg": 219,
	"./dummy_profile.jpg": 116,
	"./icons8-whatsapp.svg": 85,
	"./invoice-sign": 261,
	"./invoice-sign.js": 261,
	"./videoimg.png": 274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;